$(function () {

    //выцепляем яблоки, вешаем класс
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        $('body').addClass('ios')
    }

    //поля форм с подсказками
    if ($(".form__group--js").length) {

        var $inputs = $("input", ".form__group--js");
        var $textareas = $("textarea", ".form__group--js");

        var fn = function () {
            if ($(this).val().trim() !== "") {
                $(this).closest(".form__group").addClass("form__group--filled");
            }

            $(this).on("focus", function () {
                $(this).closest(".form__group").addClass("form__group--filled");
            });

            $(this).on("blur", function () {
                if ($(this).val().trim() === "")
                    $(this).closest(".form__group").removeClass("form__group--filled");
            });
        };

        $inputs.each(fn);

        $textareas.each(fn);
    }

    //плавный скроллинг до якоря
    var documentIsScrolled = false;
    $(".slide_to").on("click", function (e) {
        var scrollSize = $($(this).attr("href")).offset().top,
            diff = $(window).scrollTop() - scrollSize;

        if (!documentIsScrolled) {

            documentIsScrolled = true;
            if (diff > 20 || diff < -20) {

                $("body, html").animate({
                    scrollTop: scrollSize
                }, 800, function () {
                    documentIsScrolled = false;
                });
            } else {
                documentIsScrolled = false;
            }
        }

        e.preventDefault();
    });

    //Табы
    var $tabCat = $(".tabs__categories"),
        $tabCatItem = $(".tabs__categories_item"),
        $tabCatLink = $(".tabs__categories_link"),
        TAB_CAT_ITEM = ".tabs__categories_item",
        TAB_CAT_ITEM_ACTIVE = "tabs__categories_item--active",
        TAB_CONTENT_ITEM = ".tabs__content_item";

    $tabCat.find(TAB_CAT_ITEM).eq(0).addClass(TAB_CAT_ITEM_ACTIVE);

    $tabCatLink.click(function (g) {
        var tab = $(this).closest(".tabs"),
            index = $(this).closest($tabCatItem).index();

        tab.find($tabCatItem).removeClass(TAB_CAT_ITEM_ACTIVE);
        $(this).closest($tabCatItem).addClass(TAB_CAT_ITEM_ACTIVE);

        tab.find(TAB_CONTENT_ITEM).fadeOut(0);
        tab.find(TAB_CONTENT_ITEM).eq(index).fadeIn(0);

        g.preventDefault();
    });

});
